import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportingService } from '../../reporting.service';
import { saveAs } from '@progress/kendo-file-saver';
import {
  distinctUntilChanged,
  map,
  switchMap,
  startWith,
  debounceTime,
} from 'rxjs/operators';
import { AdminService } from '../../../admin/admin.service';
import { Platform } from '@angular/cdk/platform';
import { WarnDialogComponent } from '../../../warn-dialog/warn-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { GridModule } from '@progress/kendo-angular-grid';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-mutual-funds',
  templateUrl: './mutual-funds.component.html',
  styleUrls: ['./mutual-funds.component.scss'],
  imports: [
    MatSelectModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    GridModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
  ],
})
export class MutualFundsComponent implements OnInit {
  private admnSvc = inject(AdminService);
  private pltfrm = inject(Platform);
  private rptSvc = inject(ReportingService);
  private dialog = inject(MatDialog);

  @Input() baseUrl;
  unitsControl = new FormControl();
  selectedUnit;
  filteredUnits;
  mutualFund = { unit: null, start: null, end: null };
  mutualFundData = { data: null, headers: null };

  ngOnInit(): void {
    this.getUnits();
  }

  getMfReport() {
    let dialogRef = this.dialog.open(WarnDialogComponent, {
      panelClass: 'warn-dialog',
      data: {
        headline: 'Disclosure',
        aiDisclosure: true,
        confirm: 'Agree and Download',
        cancel: 'Cancel/Exit',
        hideCancel: false,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'continue') {
        const iosSafari =
          this.pltfrm.IOS ||
          (navigator?.['userAgentData']?.platform === 'macOS' &&
            navigator.maxTouchPoints > 1);

        this.rptSvc
          .getMutualFund(
            this.mutualFund.unit,
            this.mutualFund.start.toISOString(),
            this.mutualFund.end.toISOString()
          )
          .subscribe({
            next: data => {
              const filename = `${this.mutualFund.unit}_MutualFundReport.csv`;

              let fileData;
              const reader = new FileReader();
              reader.readAsDataURL(data);
              reader.onloadend = () => {
                fileData = reader.result;
                saveAs(fileData, filename, {
                  proxyURL: `${this.baseUrl}/util/proxy`,
                  proxyTarget: '_self',
                  forceProxy: iosSafari,
                });
              };
            },
            error: error => {
              console.error(error);
            },
          });
      }
      dialogRef = null;
    });
  }

  checkSelection() {
    if (
      !this.filteredUnits ||
      !this.filteredUnits.find(unit => {
        return unit.id === this.unitsControl.value;
      })
    ) {
      this.unitsControl.setValue(null);
    }
  }

  getUnits() {
    this.unitsControl.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(value => {
        if (value) {
          this.admnSvc.getUnitList(value, true).subscribe(resp => {
            if (resp['names']) {
              this.filteredUnits = resp['names'];
            }
          });
        }
      });
  }
}
